import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { getApi } from "../../../../utils/requestApi"
import { LinksTutoriaisPermissaoPastaType } from "../types"

export default async function getPermissaoLista(dispatch: Function, idLista: number, idUsuario: number) {
    const response: RequestResponsePattern<LinksTutoriaisPermissaoPastaType> = await getApi({
        endpoint: DOMAIN,
        params: `/LinksTutoriais/permissao/lista/${idLista}?idUsuario=${idUsuario}`,
    })
    if (response && !response.flagErro) {
        return response.listaResultados
    }
    throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
}
